import apiClient, { extractData } from "./client";

export async function listPlatformPlans() {
  const response = await apiClient.get("/platform/plans");
  return extractData(response);
}

export async function listPlatformTenants() {
  const response = await apiClient.get("/platform/tenants");
  return extractData(response);
}

export async function createPlatformTenant(payload) {
  const response = await apiClient.post("/platform/tenants", payload);
  return extractData(response);
}

export async function updateTenantModule(tenantId, key, enabled) {
  const response = await apiClient.patch(
    `/platform/tenants/${tenantId}/modules`,
    { [key]: enabled },
  );
  return extractData(response);
}

export async function updateTenantPlan(tenantId, planId) {
  const response = await apiClient.patch(`/platform/tenants/${tenantId}/plan`, {
    planId,
  });
  return extractData(response);
}

export async function updateTenantIndustry(tenantId, industry) {
  const response = await apiClient.patch(
    `/platform/tenants/${tenantId}/industry`,
    { industry },
  );
  return extractData(response);
}

export async function recordTenantPayment(tenantId, payload) {
  const response = await apiClient.post(
    `/platform/tenants/${tenantId}/payments`,
    payload,
  );
  return extractData(response);
}

export async function suspendTenant(tenantId) {
  const response = await apiClient.post(`/platform/tenants/${tenantId}/suspend`);
  return extractData(response);
}

export async function deletePlatformTenant(tenantId, confirmSlug) {
  const response = await apiClient.delete(`/platform/tenants/${tenantId}`, {
    data: { confirmSlug },
  });
  return extractData(response);
}

export async function updatePlatformAccount(payload) {
  const response = await apiClient.patch("/platform/account", payload);
  return extractData(response);
}

export async function getMyFeatureFlags() {
  const response = await apiClient.get("/feature-flags");
  return extractData(response);
}
